import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import fil from './locales/fil.json';

export const SUPPORTED_LANGUAGES = ['en', 'fil'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const LANGUAGE_STORAGE_KEY = 'ethosai_language';

// English is always the default on first load - a language is only ever switched away from
// English by an explicit click in the footer's language switcher, never inferred from the
// browser (no language-detector plugin here on purpose).
function storedLanguage(): SupportedLanguage {
  const stored = typeof window !== 'undefined' ? window.localStorage.getItem(LANGUAGE_STORAGE_KEY) : null;
  return (SUPPORTED_LANGUAGES as readonly string[]).includes(stored || '') ? (stored as SupportedLanguage) : 'en';
}

i18next.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    fil: { translation: fil },
  },
  lng: storedLanguage(),
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
  returnEmptyString: false,
});

export function setLanguage(lang: SupportedLanguage) {
  window.localStorage.setItem(LANGUAGE_STORAGE_KEY, lang);
  i18next.changeLanguage(lang);
}

export default i18next;
